import React from "react";
import get from "lodash/get";
import findKey from "lodash/findKey";
import find from "lodash/find";
import groupBy from "lodash/groupBy";
import map from "lodash/map";
import keys from "lodash/keys";
import i18n from "../../../i18n";

import BuildProgramStepOneModal from "../../../parts/modals/add-cycle";
import AddExerciseModal from "../../../parts/modals/add-exercise";
import DuplicateWorkoutModal from "../../../parts/modals/duplicate-workout";
import DuplicateWeekModal from "../../../parts/modals/duplicate-week";
import ProgressionModal from "../../../parts/modals/progression";
import ProgramEditorAP from "../../athlete-portal/programs/ProgramEditor";

const ProgramEditor = (app) => {
  app.get(
    "/edit-program/:cycleId",
    async ({ assert, res, req, locals, load, flash }) => {
      const {
        activeUser: {
          exerciseLibrary: { assistant },
        },
      } = locals;
      await load("editCycle", { cycle: req.params.cycleId });
      await load("editExercises", { cycle: req.params.cycleId });

      assert(
        locals.editCycle,
        400,
        i18n.t("dashboard:programEditor.invalidCycle")
      );

      const { query } = req;
      const programOrder = query.program || 1;
      const programKey = findKey(locals.editCycle.programs, {
        order: programOrder,
      });
      locals.program = locals.editCycle.programs[programKey];

      locals.activeWeek = query.week || 1;
      const modal = get(query, "modal", {});

      const editExercise = query.editMode
        ? find(locals.editExercises, { _id: query.exercise })
        : {};

      locals.weeks = groupBy(locals.program.sessions, "week");

      locals.weeksExercises = {};
      map(
        locals.weeks,
        (week, order) =>
          (locals.weeksExercises[order] = week.reduce(
            (arr, session) => arr.concat(session.exercises),
            []
          ))
      );

      // Done at the end of a long day. TODO: refactor
      // Pass an array to DuplicateWeekModal to check if a week already has exercises
      // locals.weeks takes on a weird form because the Program
      // Settings modal save button alters the exercises array in the sessions
      let duplicateCheck = [];
      for (let week in locals.weeks) {
        let hasExercises = false;
        locals.weeks[week].map((session) => {
          if (session.exercises && session.exercises.length) {
            hasExercises = true;
          }
        });
        duplicateCheck.push(hasExercises);
      }
      const sessions = groupBy(locals.program.sessions, "order");

      locals.modal = {
        "add-exercise": (
          <AddExerciseModal
            editExercise={editExercise}
            lengthAssistantLibrary={assistant.length}
            secondaryAdded={query.secondaryAdded}
          />
        ),
        "duplicate-workout": (
          <DuplicateWorkoutModal
            sessions={sessions}
            weeksOrder={keys(locals.weeks)}
          />
        ),
        "duplicate-week": (
          <DuplicateWeekModal
            weeks={locals.weeks}
            duplicateCheck={duplicateCheck}
            weeksOrder={keys(locals.weeks)}
          />
        ),
        "program-settings": <BuildProgramStepOneModal />,
        progression: <ProgressionModal />,
      }[modal.type];

      res.body = <ProgramEditorAP exercises={locals.editExercises} />;
    }
  );
};

export default ProgramEditor;
